// JsFromRoutes CacheKey 33788517db3586bce0bded4dc8a57cd2
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  archiveChallengeForms: definePathHelper('post', '/api/years/:id/archive_challenge_forms'),
  list: definePathHelper('get', '/api/years'),
  new: definePathHelper('get', '/api/years/new'),
  get: definePathHelper('get', '/api/years/:id'),
}
